import React, { useState, memo } from 'react'
import './category.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faAngleDown,
    faAngleUp,
} from '@fortawesome/free-solid-svg-icons'
const CategoryItem = ({ data, action, filter }) => {
    const [expand, setExpand] = useState(false)
    const check = ({ name, data }) => {
        if (filter.length > 0 && filter.filter(e => e.name === name && e.filter === data).length > 0) {
            return true;
        }
        return false
    }
    const FilterBtn = (props) => {
        const { data, name } = props
        const [selected, setSelected] = useState(check({ name, data }))
        return (
            <div className={`cursor-pointer font-barlow-italic line-clamp-1 rounded-full px-3 py-1 text-center ${!selected ? "default text-black" : "actived text-white"}`} onClick={() => { setSelected(!selected), action({ name: name, filter: data }) }}>{data}</div>
        )
    }
    return (
        <div className="flex flex-col text-gray-600 text-sm">
            <div onClick={() => { setExpand(!expand) }} className=" item cursor-pointer rounded-full px-8 py-2 my-2 shadow-inner flex items-center justify-between">
                <h3 className="z-10 font-barlow-italic">{data.name}</h3>
                <div className="bg-white  rounded-full w-6 h-6 justify-center flex items-center " >
                    <FontAwesomeIcon icon={expand ? faAngleUp : faAngleDown} />
                </div>
            </div>
            <div className={`flex flex-wrap mt-2 gap-3 mb-3 ${expand ? "block" : "hidden"}`}>
                {data.filter.map((item, idx) => (
                    <FilterBtn name={data.name} data={item} key={idx} className="cursor-pointer " />
                ))}
            </div>
        </div>
    )
}

export default memo(CategoryItem)